/**
 * Klávesová zkratka.
 */
enum KeyboardShortcut {
    /**
     * Vyjmutí vybraných features do schránky.
     * Mapováno na kombinaci kláves *Ctrl + X*.
     */
    CUT = 'CUT',

    /**
     * Zkopírování vybraných features do schránky.
     * Mapováno na kombinaci kláves *Ctrl + C*.
     */
    COPY = 'COPY',

    /**
     * Vložení features ze schránky.
     * Mapováno na kombinaci kláves *Ctrl + V*.
     */
    PASTE = 'PASTE',

    /**
     * Smazání vybraných features.
     * Mapováno na klávesu *Delete*.
     */
    DELETE = 'DELETE',

    /**
     * Spojení vybraných liniových features.
     * Mapováno na klávesu *S*.
     */
    MERGE_LINES = 'MERGE_LINES',

    /**
     * Editace features.
     * Mapováno na klávesu *E*.
     */
    EDIT = 'EDIT',

    /**
     * Funkce přichytávání.
     * Mapováno na klávesu *P*.
     */
    SNAP = 'SNAP',

    /**
     * Funkce nová linie s offsetem.
     * Mapováno na klávesu *Q*.
     */
    LINE_OFFSET = 'LINE_OFFSET',

    /**
     * Funkce rozdělení čáry.
     * Mapováno na klávesu *A*.
     */
    SPLIT_LINE = 'SPLIT_LINE',

    /**
     * Posuv features.
     * Mapováno na klávesu *W*.
     */
    MOVE = 'MOVE',

    /**
     * Nový bod.
     * Mapováno na klávesu *X*, pokud zvolená vkládací vrstva podporuje geometrii typu POINT.
     */
    POINT = 'POINT',

    /**
     * Nová linie.
     * Mapováno na klávesu *X*, pokud zvolená vkládací vrstva podporuje geometrii typu LINE.
     */
    LINE = 'LINE',

    /**
     * Nový polygon.
     * Mapováno na klávesu *X*, pokud zvolená vkládací vrstva podporuje geometrii typu POLYGON.
     */
    POLYGON = 'POLYGON',
}

namespace KeyboardShortcut { // eslint-disable-line
    /**
     * Všechny dostupné klávesové zkratky.
     */
    export const ALL = Object.values(KeyboardShortcut);
}

export default KeyboardShortcut;
